import {Modal, Button, Spinner, Form, Table, Pagination} from 'react-bootstrap'
import {formatPhoneNumber, parseId} from '../../../helpers'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {IResAssignLeads} from '../../../types/leads'
import {REASSIGN_LEADS_USER} from '../../../gql/mutations/leadMutations'
import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {
  IAllUserNode,
  IPipelineGroupsPipeline,
  IResAllListUsers,
} from '../../../types/users'
import {GET_ALL_USERS_LIST} from '../../../gql/queries/usersQuery'
import {GET_ALL_LIST_LEADS, GET_TOTAL_LEADS_BY_USER} from '../../../gql/queries/leadsQuery'
import {IResAllListLead, ITotalLeads} from '../leadTypes'
import moment from 'moment'
import {IStagePipelineSet} from '../../../types/pipelines'
import {useGetUser} from '../../../store/userStore'
import {URL} from '../../../gql/client'
import {GET_GROUPS_PIPELINE} from '../../../gql/queries/pipelines'

interface ModalReasingLeadsProps {
  isOpen: boolean
  onClose: () => void
  updateListLeads: () => void
  info: {
    fromUserId: string
    fromUserName: string
    pipelineId: string
    pipelineName: string
    statePipeline: string
    stateNamePipeline: string
    searchName: string
    searchPhone: string
    dateFrom: Date | null
    dateTo: Date | null
    assignType: string
    leadsSelected?: {id: string; name: string; stage: string; user: string}[]
  }
  iStagePipeline: IStagePipelineSet[] | null
  isExport: boolean
  flagView: string
}

export const ModalReasingLeads = ({
  isOpen,
  onClose,
  info,
  updateListLeads,
  iStagePipeline,
  isExport,
  flagView,
}: ModalReasingLeadsProps) => {
  const firstML = 20
  const [offsetML, setOffsetML] = useState(0)

  const [disabledAssign, setDisabledAssign] = useState(true)

  const [userFrom, setUserFrom] = useState('')
  const [userTo, setUserTo] = useState('')
  const [stageTo, setStageTo] = useState('')
  const [groupTo, setGroupTo] = useState('')
  const [byFiltersApplied, setFiltersApplied] = useState('')

  const [filteredUsers, setFilteredUsers] = useState<IAllUserNode[] | undefined>(undefined)
  const user = useGetUser((s) => s.user)
  const [loadingExportLeads, setLoadingExportLeads] = useState(false)

  const {
    data: dataMembersFrom,
    loading: loadingMember,
    error: errorMembers,
  } = useQuery<IResAllListUsers>(GET_ALL_USERS_LIST, {
    fetchPolicy: 'no-cache',
  })

  const [
    gqlGetGroupsPipeline,
    {data: dataGroupPipeline, loading: loadingGroupPipelin, error: errorGroupPipeline},
  ] = useLazyQuery<IPipelineGroupsPipeline>(GET_GROUPS_PIPELINE, {fetchPolicy: 'no-cache'})

  const [getTotalLeads, {data: countTotalLeads, loading: loadingMemberLU, error: errorMembersLu}] =
    useLazyQuery<ITotalLeads>(GET_TOTAL_LEADS_BY_USER, {
      fetchPolicy: 'no-cache',
    })

  const [gqlGetLeads, {data: allDataLeads, loading: loadingAllLeads}] =
    useLazyQuery<IResAllListLead>(GET_ALL_LIST_LEADS, {fetchPolicy: 'no-cache'})

  const [gqlCall, {data, loading, error}] = useMutation<IResAssignLeads>(REASSIGN_LEADS_USER)

  const safeParseId = (value: any): number | null => {
    const id = parseId(value) as number
    return !id || isNaN(id) || id === 0 ? null : id
  }

  const handleDownload = async () => {
    if (!user) return
    const {token} = user
    if (!token) return
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    const stagePipelineId = safeParseId(info.statePipeline)
    const pipelineId = safeParseId(info.pipelineId)
    const startDate = info.dateFrom ? moment(info.dateFrom).format('YYYY-MM-DD') : null
    const endDate = info.dateTo ? moment(info.dateTo).format('YYYY-MM-DD') : null
    const userId = safeParseId(info.fromUserId)
    const name = info.searchName
    const phone = info.searchPhone

    const rawParams: Record<string, string | null | undefined> = {
      stage_pipeline_id: stagePipelineId ? '' + stagePipelineId : null,
      stage_pipeline__pipeline_id: pipelineId ? '' + pipelineId : null,
      start_date: startDate,
      end_date: endDate,
      user_id: userId ? '' + userId : null,
      name: name,
      phone: phone,
    }

    const params = new URLSearchParams()

    Object.entries(rawParams).forEach(([key, value]) => {
      if (value != null && value !== '') {
        params.append(key, value)
      }
    })

    setLoadingExportLeads(true)
    try {
      const url = `${URL}/export-filtered-leads-excel?${params.toString()}`
      const res = await fetch(url, requestOptions)
      if (!res.ok) throw new Error('Error al exportar')
      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `leads-${moment().format('DD-MM-YY')}.xlsx`
      document.body.appendChild(link)
      setLoadingExportLeads(false)
      link.click()
    } catch (err) {
      setLoadingExportLeads(false)
      toast.error(`ERROR: ${(err as {message: string}).message}`)
    }
  }
  useEffect(() => {
    if (!info.pipelineId) return
    gqlGetGroupsPipeline({
      variables: {
        id: parseId(info.pipelineId),
      },
    })
  }, [gqlGetGroupsPipeline, info.pipelineId])

  useEffect(() => {
    const filteredUsersA = dataMembersFrom?.allUsersList.filter((user) => user.id !== userFrom)
    setFilteredUsers(filteredUsersA)

    if (userFrom)
      getTotalLeads({variables: {pipelineId: parseId(info.pipelineId), userId: parseId(userFrom)}})
  }, [dataMembersFrom, getTotalLeads, info.pipelineId, userFrom])

  useEffect(() => {
    if (!info.pipelineId) return

    if (isExport && flagView === 'list') {
      handleDownload()
      onClose()
    }

    if (info.fromUserId) {
      const filteredUsersA = dataMembersFrom?.allUsersList.filter(
        (user) => user.id !== info.fromUserId
      )
      setFilteredUsers(filteredUsersA)
    } else {
      const filteredUsersA = dataMembersFrom?.allUsersList
      setFilteredUsers(filteredUsersA)
    }

    if (info.assignType === 'by-filters' || isExport) {
      let filtersApplied = ''
      if (isExport) {
        filtersApplied += 'Pipeline [' + info.pipelineName + ']'
      }

      if (info.dateFrom && info.dateTo)
        filtersApplied +=
          'Dates from [' +
          moment(info.dateFrom).format('DD-MMM-YY') +
          '] to [' +
          moment(info.dateTo).format('DD-MMM-YY') +
          ']'
      else if (info.dateFrom)
        filtersApplied +=
          (filtersApplied.length > 0 ? ',' : '') +
          'Date from [' +
          moment(info.dateFrom).format('DD/MMM/YY') +
          '], '
      else if (info.dateTo)
        filtersApplied +=
          (filtersApplied.length > 0 ? ',' : '') +
          'Date to [' +
          moment(info.dateTo).format('DD/MMM/YY') +
          '], '

      if (info.statePipeline)
        filtersApplied +=
          (filtersApplied.length > 0 ? ', ' : '') + 'from stage [' + info.stateNamePipeline + ']'

      if (info.fromUserId && info.fromUserName)
        filtersApplied +=
          (filtersApplied.length > 0 ? ', ' : '') + 'from user [' + info.fromUserName + ']'

      if (info.searchName)
        filtersApplied +=
          (filtersApplied.length > 0 ? ', ' : '') + ' name contains "' + info.searchName + '"'

      if (info.searchPhone)
        filtersApplied +=
          (filtersApplied.length > 0 ? ', ' : '') + ' phone  contains "' + info.searchPhone + '"'

      setFiltersApplied(filtersApplied)
      console.log('gqlGetLeads By Filters', filtersApplied)
      gqlGetLeads({
        variables: {
          pipelineId: parseId(info.pipelineId),
          userId: parseId(info.fromUserId ?? ''),
          stagePipelineId:
            (parseId(info.statePipeline) as number) > 0
              ? (parseId(info.statePipeline) as number)
              : null,
          name_Icontains: info.searchName,
          phone_Icontains: info.searchPhone,
          fromDate: info.dateFrom != null ? moment(info.dateFrom).format('YYYY-MM-DD') : null,
          toDate: info.dateTo != null ? moment(info.dateTo).format('YYYY-MM-DD') : null,
          first: firstML,
          offset: offsetML,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    gqlGetLeads,
    info.assignType,
    info.dateFrom,
    info.dateTo,
    info.fromUserId,
    info.pipelineId,
    info.searchName,
    info.searchPhone,
    info.statePipeline,
    offsetML,
    firstML,
    info.stateNamePipeline,
    info.fromUserName,
    isExport,
    info.pipelineName,
  ])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
    if (errorMembers) toast.error(`Error: ${errorMembers.message}`)
    if (errorGroupPipeline) toast.error(`Error: ${errorGroupPipeline.message}`)
    if (errorMembersLu) toast.error(`Error: ${errorMembersLu.message}`)
  }, [error, errorMembers, errorMembersLu, errorGroupPipeline])

  useEffect(() => {
    setUserFrom(info.fromUserId)
  }, [info.fromUserId])

  useEffect(() => {
    setDisabledAssign(true)
    if ((userTo && !groupTo) || (!userTo && groupTo) || stageTo) {
      if (byFiltersApplied || userFrom || (info.leadsSelected && info.leadsSelected.length > 0)) {
        setDisabledAssign(false)
      }
    }
  }, [userTo, stageTo, byFiltersApplied, info.leadsSelected, userFrom, groupTo])

  useEffect(() => {
    if (!data) return
    if (data.assignLeadsToUser?.success) {
      toast.success(data.assignLeadsToUser?.message)
      updateListLeads()
      modalClose()
    } else if (data.assignLeadsToUser?.errors && data.assignLeadsToUser?.errors.length > 0) {
      toast.error(`Error: ${data.assignLeadsToUser?.errors[0]?.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleReAssignLeads = () => {
    if (isExport) return
    if (!info.pipelineId) return

    const leadIds: (number | null)[] = (info.leadsSelected ?? [])
      .map((lead) => safeParseId(lead.id))
      .filter((id): id is number => id !== null) // eliminamos los nulls si no querés enviarlos

    gqlCall({
      variables: {
        pipelineId: safeParseId(info.pipelineId),
        fromUserId: safeParseId(userFrom),
        fromStagePipelineId: safeParseId(info.statePipeline),
        fromDate: info.dateFrom ? moment(info.dateFrom).format('YYYY-MM-DD') : null,
        toDate: info.dateTo ? moment(info.dateTo).format('YYYY-MM-DD') : null,
        name_Icontains: info.searchName,
        phone_Icontains: info.searchPhone,
        toUserId: safeParseId(userTo),
        toStagePipelineId: safeParseId(stageTo),
        toGroupId: safeParseId(groupTo),
        leadIds,
      },
    })
  }

  const modalClose = (): void => {
    info = {
      fromUserId: '',
      fromUserName: '',
      pipelineId: '',
      pipelineName: '',
      statePipeline: '',
      stateNamePipeline: '',
      searchName: '',
      searchPhone: '',
      dateFrom: null,
      dateTo: null,
      assignType: '',
      leadsSelected: [],
    }
    isExport = false
    onClose()
  }

  return (
    <Modal show={isOpen} onHide={modalClose} size='xl' className='modal-reassing-leads'>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className='d-flex flex-column gap-0'>
            <span className='fw-bold '>
              {info.assignType === 'by-user' ? 'Reassign leads by user ' : ''}
              {info.assignType === 'by-filters' ? 'Reassign leads by filters: ' : ''}
              {info.assignType === 'by-leads-selected' ? 'Reassign selected leads' : ''}
            </span>
            {info.assignType === 'by-filters' && (
              <span className='filters-applied'>{byFiltersApplied}</span>
            )}
            {isExport && (
              <>
                <span className='fw-bold '>Export leads</span>
                <span className='filters-applied'>{byFiltersApplied}</span>
              </>
            )}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex flex-column gap-4'>
          <div className='reassign-leads reassign-from'>
            {info.assignType === 'by-user' && (
              <h2 className='fs-1'>
                From{' '}
                {loadingMember && (
                  <span>
                    <Spinner animation='border' size='sm' />
                  </span>
                )}
              </h2>
            )}

            {info.assignType === 'by-filters' && (
              <h2 className='fs-1'>
                Leads lists{' '}
                {loadingMember ||
                  (loadingAllLeads && (
                    <span>
                      <Spinner animation='border' size='sm' />
                    </span>
                  ))}
              </h2>
            )}
            {!loadingMember &&
              !allDataLeads &&
              dataMembersFrom &&
              info.assignType !== 'by-leads-selected' &&
              info.fromUserId && (
                <>
                  <div>
                    <Form.Select aria-label='Lead source' name='leadSource'>
                      <option value={info.fromUserId}>{info.fromUserName}</option>
                    </Form.Select>
                  </div>
                </>
              )}
            {!loadingMember &&
              !loadingAllLeads &&
              !allDataLeads &&
              dataMembersFrom &&
              !(info.leadsSelected && info.leadsSelected?.length > 0) &&
              !info.fromUserId && (
                <div>
                  <Form.Select
                    aria-label='Lead source'
                    name='leadSource'
                    value={userFrom}
                    onChange={(e) => {
                      const {value} = e.target
                      if (value) {
                        setUserFrom(value)
                      }
                      if (e.target.value === '') {
                        setUserFrom('')
                      }
                    }}
                  >
                    <option value=''>Please select</option>
                    {dataMembersFrom?.allUsersList
                      .filter((node) => node.id !== info.fromUserId)
                      .map((node) => (
                        <option key={node.id} value={node.id}>
                          {node.firstName + ' ' + node.lastName}
                        </option>
                      ))}
                  </Form.Select>
                </div>
              )}
            {info.assignType === 'by-user' && loadingMemberLU && (
              <span>
                <Spinner animation='border' size='sm' />
              </span>
            )}
            {countTotalLeads && userFrom && userFrom !== '' && info.assignType === 'by-user' && (
              <div className='total-leads-assign-to'>
                {countTotalLeads.totalLeads ?? '0'} leads to Assign
              </div>
            )}
            {(info.assignType === 'by-filters' || isExport) && loadingAllLeads && (
              <div>
                <div className='d-flex justify-content-between mb-2'>
                  <Spinner animation='border' size='sm' />
                </div>
              </div>
            )}
            {!loadingAllLeads &&
              (allDataLeads || (info.leadsSelected && info.leadsSelected?.length > 0)) && (
                <div>
                  <div className='d-flex justify-content-between mb-2'>
                    <h2 className='fs-1'>Leads lists</h2>
                    {(info.assignType === 'by-filters' || isExport) && (
                      <div className='d-flex align-items-center justify-content-end'>
                        <Pagination size='sm'>
                          <Pagination.Prev
                            disabled={offsetML === 0}
                            onClick={() => {
                              setOffsetML((p) => p - firstML)
                            }}
                          />
                          {
                            <span className='d-flex align-items-center text-secondary'>
                              {offsetML / firstML + 1}/
                              {allDataLeads?.totalLeads ? (
                                Math.ceil(allDataLeads?.totalLeads / firstML)
                              ) : allDataLeads?.totalLeads == null ? (
                                <Spinner animation='grow' size='sm' />
                              ) : (
                                allDataLeads?.totalLeads
                              )}
                            </span>
                          }
                          <Pagination.Next
                            disabled={!allDataLeads?.allLeads.pageInfo.hasNextPage}
                            onClick={() => {
                              setOffsetML((p) => p + firstML)
                            }}
                          />
                        </Pagination>
                      </div>
                    )}
                    <span
                      className='d-flex align-items-center justify-content-center px-3 py-1 text-primary'
                      style={{
                        borderRadius: '20px',
                        backgroundColor: '#ddf1ff',
                        fontWeight: 'bold',
                      }}
                    >
                      {(info.assignType === 'by-filters' || isExport) && allDataLeads?.totalLeads}
                      {info.assignType === 'by-leads-selected' &&
                      info.leadsSelected &&
                      info.leadsSelected?.length > 0
                        ? info.leadsSelected?.length
                        : ''}
                    </span>
                  </div>
                  <div className='table-scrollable table-container'>
                    <Table
                      hover
                      size='sm'
                      className='table-scrollable table-scroll table-light table-striped table-bordered table-sm'
                    >
                      <thead>
                        <tr role='row'>
                          <th className='fw-bold text-center'>#</th>
                          <th className='fw-bold'>Name</th>
                          <th className='fw-bold'>Stage</th>
                          <th className='fw-bold'>User</th>
                        </tr>
                      </thead>
                      <tbody style={{maxHeight: '300px', overflowY: 'auto'}}>
                        {allDataLeads?.allLeads?.edges
                          .slice() // Create a copy before sorting (Apollo cache arrays are immutable)
                          .sort((a, b) => a.node.stagePipeline.order - b.node.stagePipeline.order)
                          .map((lead, index) => (
                            <tr className='cursor-pointer' key={lead.node.id}>
                              <td className='text-center'>{index + offsetML + 1}</td>
                              <td>
                                {lead.node.name}
                                {info.searchPhone ? (
                                  <span className='fst-italic fs-7 p-2'>
                                    <i className='bi bi-phone fs-8'></i>
                                    {formatPhoneNumber(lead.node.phone)}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td>{lead.node.stagePipeline.name}</td>
                              <td>
                                {lead.node.user?.edges[0]?.node.firstName}{' '}
                                {lead.node.user?.edges[0]?.node.lastName}
                              </td>
                            </tr>
                          ))}
                        {info.leadsSelected?.map((lead, index) => (
                          <tr className='cursor-pointer' key={lead.id}>
                            <td className='text-center'>{index + 1}</td>
                            <td>{lead.name}</td>
                            <td>{lead.stage}</td>
                            <td>{lead.user ?? ''}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}
          </div>
          {!isExport && (
            <div className='reassign-leads reassign-to'>
              <h2 className='fs-1'>To </h2>

              <div className='row'>
                <div className='col reassign-to-group'>
                  <h4 className='fs-4'>
                    Group Assignment (Round Robin){' '}
                    {loadingGroupPipelin && (
                      <span>
                        <Spinner animation='border' size='sm' />
                      </span>
                    )}{' '}
                  </h4>

                  {!loadingMember &&
                    ((userFrom && userFrom !== '') || allDataLeads || info.leadsSelected) && (
                      <div>
                        <Form.Select
                          aria-label='Lead source'
                          disabled={userTo !== ''}
                          name='leadSource'
                          onChange={(e) => {
                            const {value} = e.target
                            if (value) {
                              setGroupTo(value)
                            }
                            if (e.target.value === '') {
                              setGroupTo('')
                            }
                          }}
                        >
                          <option value=''>Please select</option>
                          {dataGroupPipeline?.pipelineById?.groups.edges?.map(({node}) => (
                            <option key={node.id} value={node.id}>
                              {node.name}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    )}
                </div>
                <div className='col reassign-to-user'>
                  <h4 className='fs-4 text-primary'>
                    User{' '}
                    {loadingMember && (
                      <span>
                        <Spinner animation='border' size='sm' />
                      </span>
                    )}{' '}
                  </h4>
                  {!loadingMember &&
                    ((userFrom && userFrom !== '') || allDataLeads || info.leadsSelected) && (
                      <div>
                        <Form.Select
                          aria-label='Lead source'
                          name='leadSource'
                          disabled={groupTo !== ''}
                          onChange={(e) => {
                            const {value} = e.target
                            if (value) {
                              setUserTo(value)
                            }
                            if (e.target.value === '') {
                              setUserTo('')
                            }
                          }}
                        >
                          <option value=''>Please select</option>
                          {filteredUsers
                            ?.filter((node) => node.id !== info.fromUserId)
                            .map((node) => (
                              <option key={node.id} value={node.id}>
                                {node.firstName + ' ' + node.lastName}
                              </option>
                            ))}
                        </Form.Select>
                      </div>
                    )}
                </div>
                <div className='col reassign-to-stage'>
                  <h4 className='fs-4'>
                    To stage{' '}
                    {loadingMember && (
                      <span>
                        <Spinner animation='border' size='sm' />
                      </span>
                    )}
                  </h4>
                  {!loadingMember &&
                    ((userFrom && userFrom !== '') || allDataLeads || info.leadsSelected) && (
                      <div>
                        <Form.Select
                          aria-label='Lead source'
                          name='leadSource'
                          onChange={(e) => {
                            const {value} = e.target
                            if (value) {
                              setStageTo(value)
                            }
                            if (e.target.value === '') {
                              setStageTo('')
                            }
                          }}
                        >
                          <option value=''>Please select</option>
                          {iStagePipeline
                            ?.slice() // Create a copy before sorting (Apollo cache arrays are immutable)
                            .sort((a, b) => a.node.order - b.node.order)
                            .map(({node}) => (
                              <option key={node.id} value={node.id}>
                                {node.name}
                              </option>
                            ))}
                        </Form.Select>
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={(e) => {
            modalClose()
          }}
          variant='light'
        >
          Cancel
        </Button>
        {isExport && (
          <Button
            onClick={handleDownload}
            variant='primary'
            disabled={(loadingExportLeads || loadingAllLeads) && !allDataLeads}
          >
            {loading && <Spinner animation='border' className='me-2' size='sm' />}
            <i className='bi bi-download'></i>
            Export Leads
          </Button>
        )}
        {!isExport && (
          <Button onClick={handleReAssignLeads} variant='primary' disabled={disabledAssign}>
            {loading && <Spinner animation='border' className='me-2' size='sm' />}
            <i className='bi bi-person-up' />
            Reassign Leads
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
